import { render, staticRenderFns } from "./NotificationsSidebarNotification.vue?vue&type=template&id=d3cfe822&"
import script from "./NotificationsSidebarNotification.vue?vue&type=script&lang=ts&"
export * from "./NotificationsSidebarNotification.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsSidebarNotification.vue?vue&type=style&index=0&id=d3cfe822&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports